import {
  CommonIncidentId,
  RugbyUnionIncidentId,
} from '@collector/sportsapi-client-legacy'

import { PocketIncidents, PocketIncidentsConfig } from '../../../configuration'

const pocketIncidents: PocketIncidents = [
  {
    incidentId: RugbyUnionIncidentId.Timeout,
    title: 'Timeout',
  },
  {
    incidentId: RugbyUnionIncidentId.RefereeReview,
    title: 'Ref. review',
  },
  {
    incidentId: RugbyUnionIncidentId.Injury,
    title: 'Injury',
  },
  {
    incidentId: RugbyUnionIncidentId.MedicalTimeout,
    title: 'M. timeout',
  },
  {
    incidentId: CommonIncidentId.TechnicalProblems,
    title: 'T. problem',
  },
]

const morePocketIncidents: PocketIncidents = [
  {
    incidentId: RugbyUnionIncidentId.BreakDuringGame,
    title: 'Break during the game',
  },
  {
    incidentId: RugbyUnionIncidentId.WaterBreak,
    title: 'Water break',
  },
]

export const pocketIncidentsConfig: PocketIncidentsConfig = {
  pocketIncidents,
  morePocketIncidents,
  blockedPocketIncidentsMap: new Map(),
}
